export function getWindow(): Window | undefined {
    // eslint-disable-next-line no-restricted-globals
    return typeof window === 'undefined' ? undefined : window
}

export function getVisualViewport(): VisualViewport | null | undefined {
    return typeof visualViewport === 'undefined' ? undefined : visualViewport
}

export function getDocument(): Document | undefined {
    // eslint-disable-next-line no-restricted-globals
    return typeof document === 'undefined' ? undefined : document
}

export function getNavigator(): Navigator | undefined {
    // eslint-disable-next-line no-restricted-globals
    return typeof navigator === 'undefined' ? undefined : navigator
}

export function getLocation(): Location | undefined {
    // eslint-disable-next-line no-restricted-globals
    return typeof location === 'undefined' ? undefined : location
}

export function getFetch(): typeof fetch {
    // eslint-disable-next-line no-restricted-globals
    return fetch
}

export function getLocalStorage(): Storage | undefined {
    // eslint-disable-next-line no-restricted-globals
    return typeof localStorage === 'undefined' ? undefined : localStorage
}

export function getSessionStorage(): Storage | undefined {
    // eslint-disable-next-line no-restricted-globals
    return typeof sessionStorage === 'undefined' ? undefined : sessionStorage
}

export function getRequestAnimationFrame(): typeof requestAnimationFrame {
    // eslint-disable-next-line no-restricted-globals
    return typeof requestAnimationFrame === 'undefined'
        ? () => 0
        : // eslint-disable-next-line no-restricted-globals
          requestAnimationFrame
}

export function getImageConstructor(): typeof Image | undefined {
    // eslint-disable-next-line no-restricted-globals
    return typeof Image === 'undefined' ? undefined : Image
}

export function getResizeObserverConstructor():
    | typeof ResizeObserver
    | undefined {
    // eslint-disable-next-line no-restricted-globals
    return typeof ResizeObserver === 'undefined' ? undefined : ResizeObserver
}

export function getInterval():
    | {
          setInterval: typeof window.setInterval

          clearInterval: typeof window.clearInterval
      }
    | undefined {
    // eslint-disable-next-line no-restricted-globals
    if (typeof window === 'undefined') {
        return undefined
    }

    // eslint-disable-next-line no-restricted-globals
    const { setInterval, clearInterval } = window

    return {
        setInterval,
        clearInterval,
    }
}

export function getTimeout():
    | {
          setTimeout: typeof window.setTimeout

          clearTimeout: typeof window.clearTimeout
      }
    | undefined {
    // eslint-disable-next-line no-restricted-globals
    if (typeof window === 'undefined') {
        return undefined
    }

    // eslint-disable-next-line no-restricted-globals
    const { setTimeout, clearTimeout } = window

    return { setTimeout, clearTimeout }
}
